import { jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';

@jsonObject
export class AdminShippingSettingsUpdateRequest {
  @jsonMember(Number)
  public readonly labelFetchRetries!: number;

  @jsonMember(Number)
  public readonly labelsInFile!: number;

  @jsonMember(String)
  public readonly senderFirstName!: string;

  @jsonMember(String)
  public readonly senderLastName!: string;

  @jsonMember(String)
  public readonly senderEmail!: string;

  @jsonMember(String)
  public readonly senderPhonePrefix!: string;

  @jsonMember(String)
  public readonly senderPhoneNumber!: string;

  @jsonMember(String)
  public readonly senderCompanyName?: Nillable<string>;

  @jsonMember(String)
  public readonly warehouseCountryCode!: string;

  @jsonMember(String)
  public readonly warehouseCity!: string;

  @jsonMember(String)
  public readonly warehouseStreet!: string;

  @jsonMember(String)
  public readonly warehousePostCode!: string;

  @jsonMember(String)
  public readonly warehouseHouseNumber!: string;

  @jsonMember(String)
  public readonly warehouseFlatNumber?: Nillable<string>;

  public constructor(
    private readonly data: {
      labelFetchRetries: number;
      labelsInFile: number;
      senderFirstName: string;
      senderLastName: string;
      senderEmail: string;
      senderPhonePrefix: string;
      senderPhoneNumber: string;
      senderCompanyName?: Nillable<string>;
      warehouseCountryCode: string;
      warehouseCity: string;
      warehouseStreet: string;
      warehousePostCode: string;
      warehouseHouseNumber: string;
      warehouseFlatNumber?: Nillable<string>;
    },
  ) {
    this.labelFetchRetries = this.data.labelFetchRetries;
    this.labelsInFile = this.data.labelsInFile;
    this.senderFirstName = this.data.senderFirstName;
    this.senderLastName = this.data.senderLastName;
    this.senderEmail = this.data.senderEmail;
    this.senderPhonePrefix = this.data.senderPhonePrefix;
    this.senderPhoneNumber = this.data.senderPhoneNumber;
    this.senderCompanyName = this.data.senderCompanyName;
    this.warehouseCountryCode = this.data.warehouseCountryCode;
    this.warehouseCity = this.data.warehouseCity;
    this.warehouseStreet = this.data.warehouseStreet;
    this.warehousePostCode = this.data.warehousePostCode;
    this.warehouseHouseNumber = this.data.warehouseHouseNumber;
    this.warehouseFlatNumber = this.data.warehouseFlatNumber;
  }
}
